<div class="slide-image-container">
  <img [src]="imageUrl()" [alt]="altText()" class="slide-image" />
  <ng-content select="[overlay]"></ng-content>
</div>
<p class="slide-description" [ngStyle]="descriptionStyles | theme">{{ description() }}</p>
